import { useEffect, useState } from 'react'
import Spinner from '../../../../../components/Spinner'
import { useGetGuardianEvents } from 'api/family/guardian'
import { useSyncParamsWithRoute } from 'hooks/useUpdateSearchParams'
import { Pagination } from 'antd'
import EventCard from 'components/Events/Views/CardView/SingleCard'
import EmptyData from 'components/global/EmptyData'

const GuardianEvents = ({ id }: any) => {
  const [param, setParams] = useState({
    page: undefined,
    limit: undefined,
  })
  const { updateRouteParams } = useSyncParamsWithRoute(param, setParams)
  const PaginationChanger = (pagenumber: number, limit: number) => {
    updateRouteParams({ page: pagenumber, limit: limit })
  }
  const { data, isLoading, isFetching, refetch } = useGetGuardianEvents(
    id,
    param,
  )

  useEffect(() => {
    if (param.page) {
      refetch()
    }
  }, [param])
  return (
    <div>
      <div className="bg-white p-30px">
        {isFetching || isLoading ? (
          <div className="bg-white flex justify-center align-center">
            <Spinner />
          </div>
        ) : data?.records?.length ? (
          <>
            {data.records.map((event: any) => {
              return <EventCard event={event} key={event._id} />
            })}
            <div className="mb-20px mt-20px">
              {(data?.hasNextPage || data?.hasPrevPage) && (
                <div className="text-right">
                  <Pagination
                    onChange={PaginationChanger}
                    defaultCurrent={param.page}
                    total={data.count}
                    showTotal={(total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`
                    }
                    pageSize={param.limit || 10}
                    showSizeChanger={false}
                  />
                </div>
              )}
            </div>
          </>
        ) : (
          <div>
            <EmptyData message="No events" />
          </div>
        )}
      </div>
    </div>
  )
}
export default GuardianEvents
